import type { HttpClient } from '~/shared/api'
import { ApiService } from '~/shared/api'
import type { RequestRestService, RequestListResponse } from '../RequestRestService'
import { API_PREFIX } from '~/shared/const/request-services'
import type { ApiDataResponse } from '~/shared/types/api'
import type { QueryParams } from '~/shared/interfaces/params'
import { FiltersWithFavoriteModel } from '~/models/filters'
import type { InternshipStatistics } from '~/types/internship'

export class InternshipService extends ApiService {
  constructor(
    http: HttpClient,
    private readonly requestRestService: RequestRestService,
  ) {
    super(http)
  }

  readonly urls = {
    list: `${API_PREFIX}/internships`,
    filters: `${API_PREFIX}/internships/filters`,
    statistics: `${API_PREFIX}/internships/statistics`,
  }

  async getInternshipList(params: QueryParams): Promise<RequestListResponse<unknown>> {
    return this.requestRestService.getList('internships', params)
  }

  async getFiltersInternship(params?: QueryParams): Promise<FiltersWithFavoriteModel | null> {
    const res = await this.http.request<ApiDataResponse<unknown>>({
      url: this.urls.filters,
      params,
    })

    return res.data?.data ? new FiltersWithFavoriteModel(res.data.data) : null
  }

  async getStatisticsInternship(): Promise<InternshipStatistics | null> {
    const res = await this.http.request<ApiDataResponse<InternshipStatistics>>({
      url: this.urls.statistics,
      params: {
        'filter[in_groups_only]': 1,
      },
    })

    return res.data?.data ?? null
  }
}
